$(document).ready(function() {
    /* Bestsellers slider */
    $('.product-grid-bestsellers').owlCarousel({
        items: 4,
        loop: true,
        autoWidth: true,
        responsive: true,
        addClassActive: true,
        navigation : true,
        lazyLoad: true,
        navigationText: ['', ''],
        pagination: false,
        itemsDesktop: [1199, 4],
        itemsDesktopSmall: [980, 3],
        itemsTablet: [769, 3],
        itemsMobile: [479, 2],
    });
    /* New products slider */
    $('.product-grid-new-products').owlCarousel({
        items: 4,
        loop: true,
        autoWidth: true,
        responsive: true,
        addClassActive: true,
        navigation : true,
        lazyLoad: true,
        navigationText: ['', ''],
        pagination: false,
        itemsDesktop: [1199, 4],
        itemsDesktopSmall: [980, 3],
        itemsTablet: [769, 3],
        itemsMobile: [479, 2],
    });
const video = document.getElementById("video");
const circlePlayButton = document.getElementById("circle-play-b");

function togglePlay() {
    if (video.paused || video.ended) {
        video.play();
    } else {
        video.pause();
    }
}

circlePlayButton.addEventListener("click", togglePlay);
video.addEventListener("playing", function () {
    circlePlayButton.style.opacity = 0;
});
video.addEventListener("pause", function () {
    circlePlayButton.style.opacity = 1;
});
    $(function() {

        $(".faq-question").on("click", function(e) {
            e.preventDefault();
            let $this = $(this);

            if (!$this.hasClass("faq-active")) {
                $(".faq-answer").slideUp(400);
                $(".faq-question").removeClass("faq-active");
                $('.faq-arrow').removeClass("faq-rotate");
            }

            $this.toggleClass("faq-active");
            $this.next().slideToggle();
            $(".faq-arrow",this).toggleClass("faq-rotate");
        });
    });
    if ($(window).width() < 768) {
    $(function() {

        $(".accordion-title").on("click", function(e) {
            e.preventDefault();
            $(this).toggleClass("accordion-active");
            $(this).next().slideToggle();
            $(".accordion-arrow",this).toggleClass("accordion-rotate");
        });
    });
    }
    $(".zoom-modal").on("click", function (e) {
        e.preventDefault();
        $(".mob-modal, .modal--container, .modal--mask, .modal--close").css("display", "block");
        $(".mob-modal .modal--content").addClass("active");
        $("body").css("overflow", "hidden");
    })
    $(".mob-modal .modal--close").on("click", function (e) {
        e.preventDefault();
        $(".mob-modal, .modal--container, .modal--mask, .modal--close").css("display", "none");
        $(".mob-modal .modal--content").removeClass("active");
        $("body").css("overflow", "visible");
    })
});

$(window).on('theme.cart.update-complete', function() {
    $('.rebuyCartWidget').html('');
    $('.rebuyCartWidget').html('<div data-rebuy-id="46349"></div>');
    if(window.Rebuy){
        Rebuy.init();
    }
});

document.addEventListener('rebuy.add', function(event){
    $(window).trigger('cartUpdated')
    theme.partials.Cart.updateAllHtml(function() {})
});

$( document ).ready(function() {
    $( ".tabs_navs h2:first-child a" ).addClass('active');
    $( ".tabs_navs h2 a" ).on('click', function (){
        $( ".tabs_navs h2 a" ).removeClass('active');
        $(this).addClass('active');
    });

    $(window).on('scroll', () => {
        let scrollTop = $(window).scrollTop()
        let scrollHeight = $('.layout--main-content').height()

        if (screen.width > 960) {
            if (scrollTop > 480) {
                $('.tabs_navs').css('position', 'fixed');
                $('.tabs_navs').css('top', '130px');
            } else if(scrollTop < 480){
                $('.tabs_navs').css('position', 'relative');
                $('.tabs_navs').css('top', '0');
            }
            if (scrollHeight - scrollTop < 500 || scrollHeight - scrollTop > 4000) {
                $('.tabs_navs').css('position', 'relative');
                $('.tabs_navs').css('top', '0');
            } else {
                $('.tabs_navs').css('position', 'fixed');
                $('.tabs_navs').css('top', '130px');
            }
        }
        else {
            if (scrollTop > 130) {
                $('.tabs_nav').css('position', 'fixed');
                $('.tabs_nav').css('top', '68px');
            } else if(scrollTop < 130){
                $('.tabs_nav').css('position', 'relative');
                $('.tabs_nav').css('top', '0');
            }
            if (scrollHeight - scrollTop < 150 || scrollHeight - scrollTop > 3500) {
                $('.tabs_navs').css('position', 'relative');
                $('.tabs_navs').css('top', '0');
            }
        }


    })
});


